import { applyFilterForItem } from '@/components/common/page/ApplyFilter';
import { ListViewModel } from '@/definitions/view-models';
import { deleteByItem } from '@/common/deleteFromArray';

export class CommonPagePlaying {
  show = false;
  active = true;
  items: any[] = [];
  module!: ListViewModel<any, any>;

  get newItemsCount() {
    const n = this.items.length;
    if (n === 0) return undefined;
    return n;
  }

  toggle() {
    this.active = !this.active;
    if (this.active) {
      this.showNewItems();
    }
  }

  addWebsocketItem(item: any) {
    const existingItem = this.items.find((v) => v.id === item.id) || this.module.items.find((v) => v.id === item.id);
    if (applyFilterForItem(item, this.module.filter.current)) {
      if (existingItem) {
        return;
      }
      if (this.active) {
        this.module.items.unshift(item);
      } else {
        this.items.push(item);
      }
      this.module.count++;
    } else {
      if (existingItem) {
        setTimeout(() => {
          deleteByItem(this.items, existingItem);
          deleteByItem(this.module.items, existingItem);
          this.module.count--;
        }, 3000);
      }
    }
  }

  showNewItems() {
    this.module.items.unshift(...this.items);
    this.items.length = 0;
  }
}
